export default {
  hello: "Hello!",
};
